import React, { Fragment, memo, useEffect,useRef, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faSave } from '@fortawesome/free-solid-svg-icons';
import MantCorporacionesInt from './mantCorporacionesint.jsx';
import { SiteRutas } from '../../../request/RutasConfig.jsx';
import {  validaCorreo, validaTelefono } from '../../../components/Util/Util.jsx';
//Invocaciones datos
import { Corporacion_Consulta_Request, Corporacion_Guardar_Request, Corporacion_Modificar_Request } from "../../../request/MantenimientosRequest.jsx"
import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
//utilitarios
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';

//Seguridad
import Session from '../../../components/Util/session/index.jsx';
import Config from '../../../components/Util/constantes.js';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx"
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../../components/Util/seg-menu-opciones.js';

function mantCorporaciones(props) {
  let historyMenu = useHistory();
  const [token, setToken] = useSessionStorage('tokenCON', '');
  const [usuario, setUsuario] = useSessionStorage('usuarioCON');
  const mounted = useRef();
  const [codigo, setCodigo] = useState('');
  const [id, setId] = useState('');
  const [spinnerModal, setSpinnerModal] = useState(undefined);
  const [spinnerLabel, setSpinnerLabel] = useState('');
  const [spinnerTipo, setSpinnerTipo] = useState(1);
  const botones = [

      {
          name: "btnHomeC",
          clase: "btn btn-sm pull-right flipInX animated",
          evento: () => volverAtras(),
          leyenda: "",
          iclase: faReply,
          tooltip: "Volver"
      },
      {
          name: "btnGuardar",
          clase: "btn btn-sm pull-right flipInX animated",
          evento: () => ingresarDatos(),
          leyenda: "",
          iclase: faSave,
          tooltip: "Guardar"
      }
  ]

  const listaCampos = {
    Id: { value: 0, attributes: { readOnly: true, focus: false, label: 'Identificador', hidden: 'unset', Editando: false, maxLength: "20" } },
    Nombre: { value: "", attributes: { readOnly: false, focus: false, label: 'Nombre', hidden: 'unset', Editando: false, maxLength: "120" } },
    Direccion: { value: "", attributes: { readOnly: false, focus: false, label: 'Dirección', hidden: 'unset', Editando: false, maxLength: "255" } },
    Email: { value: "", attributes: { readOnly: false, focus: false, label: 'Correo Electrónico', hidden: 'unset', Editando: false, maxLength: "100" } },
    Fax: { value: "", attributes: { readOnly: false, focus: false, label: 'Fax', hidden: 'unset', Editando: false, maxLength: "15" } },
    Telefono: { value: "", attributes: { readOnly: false, focus: false, label: 'Teléfono', hidden: 'unset', Editando: false, maxLength: "15" } },
    Site: { value: "", attributes: { readOnly: false, focus: false, label: 'Sitio Web', hidden: 'unset', Editando: false, maxLength: "30" } },
    CedulaJuridica: { value: "", attributes: { readOnly: false, focus: false, label: 'Cédula Jurídica', hidden: 'unset', Editando: false, maxLength: "25" } },
  }

  const listaMod = {
    "Id": "",
    "Nombre": "",
    "Direccion": "",
    "Email": "",
    "Fax": "",
    "Telefono": "",
    "Site": "",
    "FechaActualizacion": "",
    "CedulaJuridica": "",
    "UsuarioModifica": "",
  }
  const [datos, setDatos] = useState(listaCampos);
  const [listaModel, setListaModel] = useState(listaMod);

  //Seguridad
  const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
  const [menuId, setMenuId] = useState(0);
  const [menuOpciones, setMenuOpciones] = useState([]);
  const [showModalSeguridad, setShowModalSeguridad] = useState(false);
  const [opcionValidar, setOpcionValidar] = useState(0);
  const [opcionValidarNombre, setOpcionValidarNombre] = useState('');

  const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
      setSpinnerModal(pSpinnerModal);
      setSpinnerLabel(pSpinnerLabel);
      setSpinnerTipo(pSpinnerTipo);
  }

  const llenarListaDatos = () => {
      let _Campos = datos;
      let _Datos = listaModel;
      _Datos.Id = _Campos.Id.value;
      _Datos.Nombre = _Campos.Nombre.value;
      _Datos.Direccion = _Campos.Direccion.value;
      _Datos.Email = _Campos.Email.value;
      _Datos.Fax = _Campos.Fax.value;
      _Datos.Telefono = _Campos.Telefono.value;
      _Datos.Site = _Campos.Site.value;
      _Datos.CedulaJuridica = _Campos.CedulaJuridica.value;
      _Datos.UsuarioModifica = usuario;
      return _Datos;
  }

  const asociarDatos = (pDatos) => {
      let _Campos = listaCampos;
      _Campos.Id.value = pDatos.Id;
      _Campos.Nombre.value = pDatos.Nombre;
      _Campos.Direccion.value = pDatos.Direccion;
      _Campos.Email.value = pDatos.Email;
      _Campos.Fax.value = pDatos.Fax;
      _Campos.Telefono.value = pDatos.Telefono;
      _Campos.Site.value = pDatos.Site;
      _Campos.CedulaJuridica.value = pDatos.CedulaJuridica;
      return _Campos;
  }




  const volverAtras = () => {
      historyMenu.push(SiteRutas.Corporacion);
  }

  const cargarDatos = async () => {
      let spinnerLabel = 'Cargando datos...';
      spinnerModalMostrar(true, spinnerLabel, 3)
      let _id = (props.match.params.id == '0') ? '' : props.match.params.id;

      if (_id.length > 0) {
          const response = await Corporacion_Consulta_Request(token, _id);
          if (response.Exitoso) {
              const _datos = asociarDatos(response.Datos);
              setDatos(_datos);
              setCodigo(_id);
          }
          else {
              Notificacion.error(response.Mensaje);
              spinnerModalMostrar(false, '', 3)
              volverAtras();
          }
      } else {
          setDatos(listaCampos);
          setCodigo(_id);
      }
      setId(_id);

      const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.Corporacion.value);
      let _menuId = 0;

      if (_MenuNomb.ID != undefined) {
          _menuId = _MenuNomb.ID;
      }
      const _UsuarioS = usuarioS;
      let _menuOpciones = null;

      if (_menuId > 0) {
          _menuOpciones = await cargarMenuOpciones(Config.Modulo, _UsuarioS, _menuId);
      }
      setMenuId(_menuId), setMenuOpciones(_menuOpciones)

      spinnerModalMostrar(false, '', 3)
  }


  useEffect(() => {

    if (!mounted.current) {
        const carga = async () => {
            await cargarDatos()
        }
        carga();
        mounted.current = true;
    }

}, [])


  //procesar datos
  const ingresarDatos = async () => {
      if (validarDatos()) {
          const _id = id;
          const optSegopt = optSeg.TOpciones_Menu;
          const _value = (_id > 0) ? optSegopt.Editar.value : optSegopt.Nuevo.value;
          let validar = validarMenuOpcion(_value);
          if (!validar) {
              await ingresarDatosSel();
          }
      }

  }

  const ingresarDatosSel = async () => {
      if (validarDatos()) {
        let spinnerLabel = id.length > 0 ? 'Actualizando datos' : 'Ingresando datos';
        spinnerModalMostrar(true, spinnerLabel, 3)
          const _data = llenarListaDatos();
          
          let resultado = '';
          
          console.log(`ingresarDatosSel _data:${_data}`);
          if (codigo.length > 0) {
              resultado = await Corporacion_Modificar_Request(token, JSON.stringify(_data));
          }
          else {
              resultado = await Corporacion_Guardar_Request(token, JSON.stringify(_data));
          };
          spinnerModalMostrar(false, '', 3)
          if (resultado.Exitoso == true) {
              Notificacion.success('Se actualizó la información con éxito.');
          }
          else {
              if (isNaN(resultado.Mensaje.trim())) {
                  Notificacion.error(`Error: ${resultado.Mensaje}`);
              }
              else {
                  Notificacion.success('Se almacenó la información con éxito.');
              }
          }
          volverAtras();
      }
  }

  const validarDatos = () => {
      const _datos = datos;
      if (_datos.Nombre.value.trim().length == 0) {
          Notificacion.error('Error: Debe ingresar el dato: Nombre.');
          return false;
      }
      if (_datos.Telefono.value.trim().length > 0) {
        if (!validaTelefono(_datos.Telefono.value.trim())) {
            Notificacion.error(`Error: Debe ingresar un número de teléfono válido.`);
            return false;
        }
      }
      if (_datos.Fax.value.trim().length > 0) {
        if (!validaTelefono(_datos.Fax.value.trim())) {
            Notificacion.error(`Error: Debe ingresar un número de fax válido.`);
            return false;
        }
      }
      if (_datos.Email.value.trim().length > 0) {
        if (!validaCorreo(_datos.Email.value.trim())) {
            Notificacion.error(`Error: Debe ingresar un correo electrónico válido.`);
            return false;
        }
      }

      return true;
  }


  const onChangeInput = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      let newAttributes = datos[name].attributes;
      // newAttributes.focus = true; //Se asigna foco al componente
      const Datos = Object.assign({}, datos, { [name]: { value: value, attributes: newAttributes } })
      setDatos(Datos);
  }

  //Seguridad
  const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
      try {

          let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
          if (listMO.Exitoso === false) {
              return null;
          }
          return listMO.Datos;
      }
      catch (err) {
          Notificacion.error(`Error: cargarMenuOpciones.`);
      }
  }

  const cargarMenuNombre = async (pModulo, pMenuNombre) => {
      try {
          let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
          if (listMON.Exitoso == false) {
              return null;
          }
          return listMON.Datos;
      }
      catch (err) {
          Notificacion.error(`Error: cargarMenuNombre.`);
      }
  }

  const validarMenuOpcion = (pOpcion) => {
      let validar = false;
      let _menuOpciones = menuOpciones;
      const optSegopt = optSeg.TOpciones_Menu;
      let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
      if (resultado.length > 0) {
          if (resultado[0].Opcion_Validar) {
              setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
              validar = true;
          }
      } else {
          setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
          validar = true;
          //Notificacion.error('No existe opción en la seguridad');
      }
      return validar;
  };

  const handleCerrarModal = () => setShowModalSeguridad(false);

  const onActionResultModal = (pValido) => {
      if (pValido) {
          let _OpcionNom = opcionValidarNombre;
          setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
          const _optSegopt = optSeg.TOpciones_Menu;
          switch (_OpcionNom) {
              case _optSegopt.Nuevo.value:
                  ingresarDatosSel();
                  break;
              case _optSegopt.Editar.value:
                  ingresarDatosSel();
                  break;
              default:
                  break;
          }
      }
  }


  return (
      <Fragment>
          <MantCorporacionesInt
              botones={botones}
              Titulo={'Corporación'}
              Datos={datos}
              onChangeInput={onChangeInput}
          />
          <ModalSpinner
              selectedModal={spinnerModal}
              contentLabel={'spinnerModalProgress'}
              label={spinnerLabel}
              tipoSpinner={spinnerTipo}
          />
          <ModalSeguridad
              //token={this.props.token}
              modalTitle={'Requiere Permisos'}
              menuId={menuId}
              opcionId={opcionValidar}
              show={showModalSeguridad}
              onActionResult={onActionResultModal}
              onHide={handleCerrarModal}
          />
      </Fragment>
  );
};
export default withRouter(memo(mantCorporaciones));